module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aSUyZi/media/FC-9781035806881.jpg?1684515200978",
      "alt": "This image is the cover for the book A Slaver’s Tide"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Slaver’s Tide\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When George Tyler, captain of the slave ship Charlotte, is becalmed in the middle of the Atlantic, time is not on his side. In the cargo hold are hundreds of thirsty slaves, and water supplies are low. Running out of options Tyler orders the crew to do the unthinkable and throw many of the slaves overboard to drown. As Tyler sails back into Bristol, the story of the Charlotte ignites a debate about the future of slavery. On one side are the abolitionists, determined to force the government to end slavery; on the other, the traders themselves, uncaring about anything except maintaining the wealth the trade brings. And in the middle, imprisoned and awaiting trial for murder, Tyler must confront his own morality and pick a side – the abolitionists or the traders. Told from the perspective of the men who ran the trade and the sailors who participated in it, and those who worked to end slavery, A Slaver’s Tide is at times confronting, shocking and moving. It is the story of the best and worst of humanity and one man’s journey through guilt and damnation to what lies beyond.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Page\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James Page was born and educated in Australia. He worked in the public and private sectors, including the occasional interaction with, and writing speeches for government ministers, and projects with corporate Australia. Hoping to rediscover his soul, he turned to writing. His other work is The Chancer’s Corp.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0